import React, { Component } from 'react';

import Checkbox from '@material-ui/core/Checkbox';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormGroup from '@material-ui/core/FormGroup';
import FormLabel from '@material-ui/core/FormLabel';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import { navigate, RouteComponentProps } from '@reach/router';
import moment from 'moment';

import { IInvitationStore } from '../../../../store/player/invitation/store';
import { IProfileActions } from '../../../../store/user/actions';
import { IProfileStore, IUserStore } from '../../../../store/user/store';

import Button from '../../../../components/Button';
import DatePicker from '../../../../components/DatePicker';
import { FormConsumer, FormProvider, IFormAttributes } from '../../../../components/Forms';
import Input from '../../../../components/Input';
import Modal from '../../../../components/Modal';
import { withContext } from '../../../../contrib/utils';
import { redWaglLogo } from '../../../../assets/images/';
import info from './modals.json';

interface IProps extends RouteComponentProps {
  actions: { user: IProfileActions };
  clubId: number;
  user: IUserStore;
  invitation: IInvitationStore;
}

interface IState {
  birthDateInfoModalOpen: boolean;
  ghinInfoModalOpen: boolean;
  render: boolean;
}

class GolfInfoComponent extends Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);

    this.state = {
      birthDateInfoModalOpen: false,
      ghinInfoModalOpen: false,
      render: false
    };

    this.onSubmit = this.onSubmit.bind(this);
    this.toggleBirthDateInfo = this.toggleBirthDateInfo.bind(this);
    this.toggleGhinInfo = this.toggleGhinInfo.bind(this);
  }

  public async componentDidMount(): Promise<void> {
    await this.props.actions.user.getOrRetrieve();
    this.setState({ render: true });
  }

  public async onSubmit(updatedFields: IProfileStore): Promise<void> {
    const response = await this.props.actions.user.updateProfile(updatedFields);
    if (!response.errors) {
      if (!this.props.invitation.event) {
        navigate(this.props.clubId ? `/register/complete/${this.props.clubId}` : '/');
      } else {
        navigate(`/event/${this.props.invitation.event}`);
      }
    }
  }

  public toggleGhinInfo(): void {
    this.setState({ ghinInfoModalOpen: !this.state.ghinInfoModalOpen });
  }

  public toggleBirthDateInfo(): void {
    this.setState({ birthDateInfoModalOpen: !this.state.birthDateInfoModalOpen });
  }

  public render(): JSX.Element {
    const { user } = this.props;
    return (
      <div>
        {this.state.render && (
          <FormProvider
            defaultValues={{ ...user.profile, hasGhin: true }}
            onSubmit={this.onSubmit}
            validations={{
              birthDate: 'date',
              gender: 'required'
            }}
          >
            <FormConsumer>
              {({ values, formActions: { setValue, toggleValue }, errors }: IFormAttributes) => (
                <div className="golf-info form override">
                  <div className="logo-wrapper">
                    <img src={redWaglLogo} className="logo" alt="Logo" />
                  </div>

                  <h1 className="golf-info__title">GOLF INFORMATION</h1>

                  <div className="golf-info-ghin">
                    <Modal
                      id="ghin-info-modal"
                      {...info.ghinNumber}
                      open={this.state.ghinInfoModalOpen}
                      onClose={this.toggleGhinInfo}
                    />
                    <Input
                      label="WHAT IS YOUR GHIN NUMBER"
                      id="ghin-number"
                      type="text"
                      value={values.ghinNumber}
                      onChange={setValue('ghinNumber')}
                      hasError={errors.ghinNumber}
                      disabled={!values.hasGhin}
                      fullWidth={true}
                    />
                    <Button
                      id="ghin-info-button"
                      color="primary"
                      className="golf-info-help-button"
                      classes={{
                        label: 'golf-info-help-button__label'
                      }}
                      disableRipple={true}
                      onClick={this.toggleGhinInfo}
                    >
                      What's this?
                    </Button>
                  </div>

                  <FormGroup row={true} className="ghin-checkbox override">
                    <FormControlLabel
                      classes={{
                        label: 'ghin-checkbox__label override'
                      }}
                      control={
                        <Checkbox
                          className="ghin-checkbox__icon override"
                          id="toggle-ghin"
                          checked={!values.hasGhin}
                          onChange={toggleValue('hasGhin')}
                          icon={<CheckBoxOutlineBlankIcon color="primary" />}
                          checkedIcon={<CheckBoxIcon />}
                          value="on"
                          color="primary"
                        />
                      }
                      label="I DON’T HAVE A GHIN"
                    />
                  </FormGroup>

                  <div className="golf-info-birthdate">
                    <div className="golf-info-birthdate__extra-label">TYPE IN YOUR BIRTHDATE</div>
                    <Modal
                      id="birthdate-info-modal"
                      {...info.birthDate}
                      open={this.state.birthDateInfoModalOpen}
                      onClose={this.toggleBirthDateInfo}
                    />
                    <DatePicker
                      className="golf-info-birthdate__datepicker"
                      id="birthdate"
                      label=""
                      placeholder="10/10/2018"
                      value={values.birthDate}
                      onChange={setValue('birthDate')}
                      onError={setValue('birthDate')}
                      maxDate={moment()
                        .add(-5, 'years')
                        .format('YYYY-MM-DD')}
                    />
                    <Button
                      id="birthdate-info-button"
                      color="primary"
                      className="golf-info-help-button"
                      classes={{
                        label: 'golf-info-help-button__label'
                      }}
                      disableRipple={true}
                      onClick={this.toggleBirthDateInfo}
                    >
                      Why are we asking?
                    </Button>
                  </div>

                  <FormControl className="golf-info-gender override">
                    <FormLabel className="golf-info-gender__label override">
                      WHAT IS YOUR GENDER?
                    </FormLabel>
                    <RadioGroup
                      aria-label="Gender"
                      name="gender"
                      id="gender"
                      value={values.gender}
                      onChange={setValue('gender')}
                      className="golf-info-radio-group override"
                      color="primary"
                      row={true}
                    >
                      <FormControlLabel
                        className="golf-info-radio override"
                        classes={{
                          label: 'golf-info-radio__label override'
                        }}
                        color="primary"
                        value="M"
                        control={
                          <Radio className="golf-info-radio__icon override" color="primary" />
                        }
                        label="Male"
                      />
                      <FormControlLabel
                        className="golf-info-radio override"
                        classes={{
                          label: 'golf-info-radio__label override'
                        }}
                        color="primary"
                        value="F"
                        control={
                          <Radio className="golf-info-radio__icon override" color="primary" />
                        }
                        label="Female"
                      />
                    </RadioGroup>
                  </FormControl>

                  <Button
                    variant="contained"
                    color="primary"
                    disabled={errors.FORM || !(values.ghinNumber || !values.hasGhin)}
                    type="submit"
                    className="register-next-button button--shadow"
                  >
                    NEXT
                  </Button>
                </div>
              )}
            </FormConsumer>
          </FormProvider>
        )}
      </div>
    );
  }
}

const GolfInfo = withContext(GolfInfoComponent, 'user', 'invitation');

export { GolfInfo };
